import svgConverter from '../util/svg_converter';

$(document).on("turbo:load", initStructure);

function initStructure() {
  itemList = $('[data-function="app-sort-list"]');
  if (itemList.length > 0) {
    var itemSortUrl = itemList.data('sort-url');
    $(itemList).sortable({
      items: ".sorting-item",
      handle: ".overlay-sort",
      axis: "y",
      stop: function(event,ui) {
        data = ($(this).sortable('toArray'));
        $.post(itemSortUrl, {order: data});
      }
    });
  }

  // Add custom fonts to structure elements
  if ($('.structure-container').length > 0) {
    var styles = $('#branding_styles');
    if($('.main-screen').length > 0){
        if (styles[0] && styles[0].innerHTML.indexOf('title-style') >= 0) {
            $('.main-screen :header').addClass('title-style')
        }
        if (styles[0] && styles[0].innerHTML.indexOf('text-style') >= 0) {
            $('.main-screen .overview').addClass('text-style')
        }
    }
    if($('.ui-sortable .node-link .node-link-inner .flex-left .app-details').length > 0){
        if (styles[0] && styles[0].innerHTML.indexOf('list-title-style') >= 0) {
            $('.ui-sortable .node-link .node-link-inner .flex-left .app-details .app-title').addClass('list-title-style')
        }
        if (styles[0] && styles[0].innerHTML.indexOf('list-summary-style') >= 0) {
            $('.ui-sortable .node-link .node-link-inner .flex-left .app-details .app-overview').addClass('list-summary-style')
        }
    }
      if($('.structure-container .main-screen-nav-bar .ui-sortable .content-link .node-link-inner .flex-left .app-details').length > 0){
          if (styles[0] && styles[0].innerHTML.indexOf('list-title-style') >= 0) {
              $('.structure-container .main-screen-nav-bar .ui-sortable .content-link .node-link-inner .flex-left .app-details .app-title').addClass('list-title-style')
          }
          if (styles[0] && styles[0].innerHTML.indexOf('list-summary-style') >= 0) {
              $('.structure-container .main-screen-nav-bar .ui-sortable .content-link .node-link-inner .flex-left .app-details .app-overview').addClass('list-summary-style')
          }
      }

    // Replace all SVG images with inline SVG
    $('img.svg').each(function () {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      $.get(imgURL, function (data) {
        var $svg = $(data).find('svg');

        if (typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if (typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }
        if ($svg.hasClass("nav-bar-panel")) {
          $svg.css('fill', $('.nav-bar').attr('nav-bar-panel'));
        } else if ($svg.hasClass("nav-bar-icon")) {
          $svg.css('fill', $('.nav-bar').attr('nav-bar-icon'));
        }

        $svg = $svg.removeAttr('xmlns:a');
        $img.replaceWith($svg);

        if ($svg.parent().hasClass("center-btn")) {
          $svg.parent().css('background-color', $('.nav-bar').attr('nav-bar-btn'));
        }
      }, 'xml');
    });
  }
  svgConverter();

    if ($('#custom-form-preview').length > 0) {
        $.ajax(
            {
                url: $('#custom-form-preview').data('form-url'),
                success: function (data) {
                    $('#custom-form-preview').html(data.form);
                    $('#preview-form').validate({
                        errorPlacement: function(error, element) {
                            addErrorLabelToElement(error, element);
                        }
                    });
                    bindSubmitToPreviewForm();
                    bindClickToSubmitButton();
                    checkboxLikeRadioBehavior()
                }
            }
        );
    }
}
